import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarStore {
  private readonly _isCollapsed = signal(false);
  private readonly _isMobileOpen = signal(false);

  readonly isCollapsed = this._isCollapsed.asReadonly();
  readonly isMobileOpen = this._isMobileOpen.asReadonly();

  toggle() {
    this._isCollapsed.update((v) => !v);
  }

  collapse() {
    this._isCollapsed.set(true);
  }

  expand() {
    this._isCollapsed.set(false);
  }

  openMobile() {
    this._isMobileOpen.set(true);
  }

  closeMobile() {
    this._isMobileOpen.set(false);
  }

  toggleMobile() {
    this._isMobileOpen.update((v) => !v);
  }
}
